import Comment from '@/models/Comment'

export default {

  namespaced: true,

  state: {
    comment: new Comment
  },

  mutations: {
    clearComment: (state) => state.comment = new Comment,
    setComment: (state, payload) => state.comment = payload,
    content: (state, payload) => state.comment.content = payload,
  },

  getters: {
    comment: state => state.comment
  }

}